export const MULTIPLE_CHOICE = "multi";
export const TRUE_FALSE = "tf";
export const QUESTION_TYPES = [TRUE_FALSE, MULTIPLE_CHOICE];
